$(document).on('click', '#testimotion_show', function() {
    Swal.fire({
        titleText: 'Отправить отзыв',
        input: 'textarea',
        inputPlaceholder: 'Опишите проблему или поделитесь мнением',
        width: 600,
        confirmButtonText: 'Отправить',
        showCancelButton: true,
        cancelButtonText: 'Отменить',
        heightAuto: false,
        showLoaderOnConfirm: true,
        focusConfirm: false,
        target: 'body',
        preConfirm: (message) => {
            Swal.disableInput();
            var data = new FormData()
            data.append('topic', 'Отзыв с: ' + window.location.pathname)
            data.append('message', message)
            return fetch('/alert/service/support', { method: "POST", headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }, body: data })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(response.statusText)
                    }
                    return response.json()
                })
                .then((data) => {
                    if (data.status == 'error' || data.status == 'warning') {
                        Swal.showValidationMessage(data.message);
                    }
                    Swal.enableInput();
                    return data;
                })
                .catch((error) => {
                    Swal.showValidationMessage(error);
                    Swal.enableInput();
                });
        },
        allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
        if (result.value.status !== undefined) Swal.fire({ icon: result.value.status, title: result.value.message });
    })
});
